import React, { Suspense } from 'react';

import { IApplicationPage } from 'application/pages/types';
import PAGES_CONST from 'application/pages/constants';
import { LocalAccessRoles } from '@shared/config';
import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

const Renderer = React.lazy(() => import('./renderer'));

export const LOCK_PAGE_PATH = '/lock';

const LockPageWrapper: IApplicationPage = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

LockPageWrapper.config = {
  routes: [
    {
      path: LOCK_PAGE_PATH,
    },
  ],
  access: [LocalAccessRoles.AUTHORIZED],
};

export default LockPageWrapper;
